import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { MainLayout } from '../../components/layout/MainLayout';

interface CommercialService {
  id: number;
  name: string;
}

/**
 * AdminCondominiumListPage - Lista de condomínios para administração
 * Equivalente a: admin/residence_users_registration/index.html.erb
 */
export default function AdminCondominiumListPage() {
  const { t } = useTranslation();
  const [commercialServices, setCommercialServices] = useState<CommercialService[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCondominiums = async () => {
      try {
        // TODO: Criar endpoint API para listar condomínios do admin
        const response = await api.get('/api/v1/admin/commercial_services');
        setCommercialServices(response.data);
      } catch (err) {
        console.error('Error fetching condominiums:', err);
        setError(t('views.admin.load_error', 'Erro ao carregar condomínios'));
        // Dados mock para desenvolvimento
        setCommercialServices([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCondominiums();
  }, []);

  return (
    <MainLayout>
      <div className="flex flex-wrap">
        <div className="w-full bg-white rounded-lg shadow border border-[#337ab7]">
          <div className="bg-[#337ab7] text-white px-4 py-3 rounded-t-lg font-medium">{t('views.admin.choose_condominium', 'Escolha um dos condomínios abaixo:')}</div>
          <div className="p-4">
            {isLoading ? (
              <div className="text-center py-4">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#337ab7] mx-auto" role="status">
                  <span className="sr-only">{t('common.loading', 'Carregando...')}</span>
                </div>
              </div>
            ) : error ? (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">{error}</div>
            ) : (
              <div className="mt-5 border rounded-lg overflow-hidden">
                {commercialServices.length > 0 ? (
                  commercialServices.map((service) => (
                    <Link
                      key={service.id}
                      className="block px-4 py-3 border-b last:border-b-0 hover:bg-gray-50 transition-colors"
                      to={`/admin/condominio/${service.id}`}
                    >
                      <i className="fas fa-map-marker-alt mr-2"></i>
                      {service.name}
                    </Link>
                  ))
                ) : (
                  <div className="px-4 py-3">
                    <i>
                      {t('views.admin.no_condominium_access', 'Você não tem acesso à nenhum condomínio. Peça acesso ao condomínio desejado através do e-mail')}{' '}
                      <a href="mailto:atendimento@laager.com.br">atendimento@laager.com.br</a>.
                    </i>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
